import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {currentResource, labels} from '../../util/utils';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function FilterOptionsReducer(
	state = initialState.filterOptions,
	action
) {
	switch (action.type) {
		case types.GET_TIME_PHASES: {
			let filterOptions = _.cloneDeep(state);
			let timephases = [];
			action.response.forEach((timephase) => {
				timephase.timePhases.length > 0 &&
					timephase.timePhases.forEach((timephaseitem) => {
						timephases.push({
							id: timephaseitem.id,
							name: timephaseitem.periodName
						});
					});
			});

			let orderedTimephases = _.orderBy(timephases, ['name'], ['asc']);
			orderedTimephases.push({
				id: 0,
				name: labels.noTimePhase
			});

			filterOptions[
				filterOptions.findIndex((x) => {
					return x.id == action.filterId;
				})
			] = {
				id: action.filterId,
				filterType: 'TimePhase',
				values: orderedTimephases
			};

			return filterOptions;
		}

		case types.GET_ENGAGEMENT_ENTITIES: {
			let filterOptions = _.cloneDeep(state);
			filterOptions[
				filterOptions.findIndex((x) => {
					return x.id == action.filterId;
				})
			] = {id: action.filterId, filterType: 'Entity', values: action.response};

			return filterOptions;
		}

		case types.GET_ENGAGEMENT_USERS: {
			let filterOptions = _.cloneDeep(state);
			let roles = _.cloneDeep(action.payload.roles);

			_.each(action.response.users, function(user) {
				user.id = user.userId,
				user.name = user.firstName + " " + user.lastName
			});

			let assignmentUsersEngagementRoles = action.response.users.concat([
				{id: '', name: labels.roles}
			]);
			_.each(roles, function(role) {
				assignmentUsersEngagementRoles.push({
					id: role.id,
					name: role.name
				});
			});

			assignmentUsersEngagementRoles.push({
				id: 0,
				name: labels.unassigned
			});

			filterOptions[
				filterOptions.findIndex((x) => {
					return x.filterType == 'AssignedTo';
				})
			] = {
				id: 3,
				filterType: 'AssignedTo',
				values: assignmentUsersEngagementRoles
			};

			filterOptions[
				filterOptions.findIndex((x) => {
					return x.filterType == 'ReviewNotesAssignedTo';
				})
			] = {
				id: 7,
				filterType: 'ReviewNotesAssignedTo',
				values: action.response.users
			};

			filterOptions[
				filterOptions.findIndex((x) => {
					return x.filterType == 'ReviewNotesCreatedBy';
				})
			] = {
				id: 8,
				filterType: 'ReviewNotesCreatedBy',
				values: action.response.users
			};

			return filterOptions;
		}
		case types.GET_OPEN_ASSIGNMENT_ROLES: {
			let filterOptions = _.cloneDeep(state);

			let assignmentRoles = action.response.map((filterOption) => {
				return {
					...filterOption,
					loadOptionsFromServer: true,
					hasChild: true,
					filterType: 'AssignmentsUsersEngagementRoles'
				};
			});

			assignmentRoles.push({
				id: 0,
				name: labels.preparer,
				loadOptionsFromServer: true,
				hasChild: true,
				filterType: 'AssignmentsUsersEngagementRoles'
			});

			filterOptions[
				filterOptions.findIndex((x) => {
					return x.id == action.filterId;
				})
			] = {
				id: action.filterId,
				filterType: 'OpenAssignment',
				values: assignmentRoles
			};
			return filterOptions;
		}

		case types.GET_OPEN_ASSIGNMENT_USERS: {
			let filterOptions = _.cloneDeep(state);
			let roles = _.cloneDeep(action.payload.roles);
			_.each(action.response.users, function(user) {
				user.id = user.userId,
				user.name = user.firstName + " " + user.lastName
			});

			let index = filterOptions.findIndex((x) => {
				return x.id == 'OpenAssignment' + '|' + action.filterId;
			});

			let assignmentUsersEngagementRoles =
				roles.length == 0
					? action.response.users
					: action.response.users.concat([{id: '', name: labels.roles}]);

			_.each(roles, function(role) {
				assignmentUsersEngagementRoles.push({
					id: role.id,
					name: role.name
				});
			});

			if (index > -1) {
				filterOptions[index] = {
					id: 'OpenAssignment' + '|' + action.filterId,
					filterType: 'AssignmentsUsersEngagementRoles',
					values: assignmentUsersEngagementRoles
				};
			} else {
				filterOptions.push({
					id: 'OpenAssignment' + '|' + action.filterId,
					filterType: 'AssignmentsUsersEngagementRoles',
					values: assignmentUsersEngagementRoles
				});
			}
			return filterOptions;
		}
		default:
			return state;
	}
}
